import { createAction } from "typesafe-actions";
const domain = "block-bulk-operation";
const setBulkActions = "/setBulkActions";
const changeBulkActionStatus = "/changeBulkActionStatus";
const clearBulkActions = "/clearBulkActions";
const removeBulkActions = "/removeBulkActions";
const setBulkActionsItems = "/setBulkActionsItems";
const setValidationResults = "/setValidationResults";
const saveOperationId = "/saveOperationId";
var PollingState = /* @__PURE__ */ ((PollingState2) => {
  PollingState2[PollingState2["Start"] = 0] = "Start";
  PollingState2[PollingState2["InProgress"] = 1] = "InProgress";
  PollingState2[PollingState2["Finished"] = 2] = "Finished";
  return PollingState2;
})(PollingState || {});
const bulkActionsActions = {
  loadItems: createAction(`${domain}/loadItems`)(),
  validate: createAction(`${domain}/validate`)(),
  apply: createAction(`${domain}/apply`)(),
  perform: createAction(`${domain}/perform`)(),
  instantOperation: createAction(`${domain}/onClickOperation`)(),
  retry: createAction(`${domain}/retry`)(),
  fetchOperations: createAction(`${domain}/fetchOperations`)(),
  setBulkActionsItems: createAction(`${domain}${setBulkActionsItems}`)(),
  setBulkActions: createAction(`${domain}${setBulkActions}`)(),
  changeBulkActionStatus: createAction(`${domain}${changeBulkActionStatus}`)(),
  clearBulkActions: createAction(`${domain}${clearBulkActions}`)(),
  removeBulkActionsWithKey: createAction(`${domain}${removeBulkActions}`)(),
  setValidationResults: createAction(`${domain}${setValidationResults}`)(),
  saveOperationId: createAction(`${domain}${saveOperationId}`)(),
  cleanOperationIds: createAction(`${domain}/cleanOperationIds`)(),
  saveOperationError: createAction(`${domain}/saveOperationError`)()
};
export {
  PollingState,
  bulkActionsActions
};
//# sourceMappingURL=actions.js.map
